import Skeleton from 'react-loading-skeleton'
import { hasAtLeast } from 'remeda'
import { SuggestedHorizontalProduct } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProduct'
import { SuggestedHorizontalProductSkeleton } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProductSkeleton'
import { dataTestIds } from '@velasca/constants'
import { useCartSuggestedProducts } from '@velasca/hooks/use-cart-suggested-products'
import { SansText } from '@velasca/ui/sans-text'
import { Separator } from '@velasca/ui/separator'
import { trackEvent } from '@velasca/utils/track-event'
import { Listing, RelatedProductsList } from './MobileSuggestedProducts.styles'

export const MobileSuggestedProducts = () => {
  const {
    data,
    error,
    loading,
    title,
    onAddToCartAddEventName,
    onQuickAddEventName,
  } = useCartSuggestedProducts()

  if (error) {
    return null
  }

  return loading ? (
    <Listing>
      <Separator />
      <Skeleton />
      <RelatedProductsList>
        {[1, 2, 3].map((e) => (
          <SuggestedHorizontalProductSkeleton key={e} />
        ))}
      </RelatedProductsList>
    </Listing>
  ) : (
    data && hasAtLeast(data, 1) && (
      <Listing>
        <Separator />
        <SansText
          fontWeight="600"
          color="dark"
          size="md"
          margin="2rem 0 2rem 0"
        >
          {title}
        </SansText>
        <RelatedProductsList
          data-testid={dataTestIds.MOBILE_SUGGESTED_PRODUCTS}
        >
          {data?.map(
            ({
              id,
              title: productTitle,
              sizes,
              customProductType,
              isGiftCard,
              productType,
              variants,
            }) => (
              <SuggestedHorizontalProduct
                loading={loading}
                key={id}
                variant={variants[0]}
                title={productTitle}
                productType={productType}
                sizes={sizes}
                customProductType={customProductType}
                isGiftCard={isGiftCard}
                onAddToCart={(handle) => {
                  onAddToCartAddEventName &&
                    trackEvent({
                      googleAnalytics: {
                        eventName: onAddToCartAddEventName,
                        data: { handle },
                      },
                    })
                }}
                onQuickAdd={(handle) => {
                  onQuickAddEventName &&
                    trackEvent({
                      googleAnalytics: {
                        eventName: onQuickAddEventName,
                        data: { handle },
                      },
                    })
                }}
              />
            ),
          )}
        </RelatedProductsList>
      </Listing>
    )
  )
}
